import { ComponentProps } from 'react';
import { vars } from 'src/core/themes';
import { ErrorOutlineIcon, IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import { ButtonWithIcon } from './ButtonWithIcon';

export const RejectButton = ({
  textContentId,
  variant,
  iconOnlyMode,
  icon,
  ...props
}: ComponentProps<typeof ButtonWithIcon>) => {
  return (
    <ButtonWithIcon
      {...props}
      icon={
        icon ?? (
          <ErrorOutlineIcon
            withHoverEffect
            fill={
              iconOnlyMode || (variant && variant !== 'regular')
                ? IconsFill.textNegative
                : IconsFill.textInverted
            }
            size={vars.iconSize.m}
          />
        )
      }
      iconOnlyMode={iconOnlyMode}
      variant={variant}
      textContentId={textContentId || ContentId.RejectSale}
    />
  );
};
